import * as t from 'io-ts';

import {RCustomFieldAttribute} from '../../../../models/api/customFieldAttributeModel';
import {RDomain} from '../../../../models/api/domainModel';
import {RAsyncStatus} from '../../../appTypes';

/*
 * Runtime types.
 */

export const RCreateAccountFormStateDirty = t.type({
  name: t.string,
  description: t.string,
  avatarFile: t.unknown, // File type
  domains: t.readonlyArray(RDomain),
  customAttributes: t.readonlyArray(RCustomFieldAttribute),
  createStatus: t.union([RAsyncStatus, t.undefined]),
});

/*
 * Types.
 */

export interface CreateAccountFormState extends Readonly<t.TypeOf<typeof RCreateAccountFormStateDirty>> {
  avatarFile: File | undefined;
}
export const RCreateAccountFormState = t.clean<CreateAccountFormState>(RCreateAccountFormStateDirty as any);
